export default "__VITE_ASSET__DmBd8OtH__"